import { styled } from "@mui/material"
import {
  DashboardInfoBanner,
  DashboardInfoBannerCaption,
  DashboardInfoBannerTitle,
} from "@pharmupp/p3-front-commons"
import { Minus } from "react-feather"
import { useAdherentSummaryApi } from "../../Adherent"
import { MyNegativeSegmentationBanner } from "./MyNegativeSegmentationBanner"

const CONTENT_OFFSET = 1.5

export const PharmacyInfoBanner = ({
  pharmacyId,
}: {
  pharmacyId?: string
}) => {
  const isViewingItsOwnPharmacy = !pharmacyId
  const { summary } = useAdherentSummaryApi({ adherentId: pharmacyId })

  // LOADING / ERROR
  if (!summary) return null

  // OWN PHARMACY + NEGATIVE SEGMENTATION
  if (isViewingItsOwnPharmacy && summary.negativeSegmentation) {
    return (
      <MyNegativeSegmentationBanner
        offset={CONTENT_OFFSET}
        centralBusinessId={summary.centralBusinessId}
        cipCode={summary.cipCode}
      />
    )
  }

  return <PharmacyInfoBannerInner {...summary} />
}

const PharmacyInfoBannerInner = ({
  negativeSegmentation,
  name,
  centralBusinessId,
  cipCode,
}: {
  negativeSegmentation: boolean
  name: string
  centralBusinessId: string
  cipCode: string
}) => (
  <DashboardInfoBanner
    offset={CONTENT_OFFSET}
    variant={negativeSegmentation ? "negativeSegmentation" : undefined}
  >
    {negativeSegmentation && <Icon />}
    <DashboardInfoBannerTitle>{name}</DashboardInfoBannerTitle>
    <DashboardInfoBannerCaption>{`ID : ${centralBusinessId}`}</DashboardInfoBannerCaption>
    {" - "}
    <DashboardInfoBannerCaption>{`CIP : ${cipCode}`}</DashboardInfoBannerCaption>
    {negativeSegmentation && (
      <>
        <b>{" - "}</b>
        <DashboardInfoBannerTitle color="negativeSegmentation.main">
          Pharmacie en segmentation negative
          <DashboardInfoBannerCaption>&nbsp;:</DashboardInfoBannerCaption>
        </DashboardInfoBannerTitle>
        <DashboardInfoBannerCaption>
          le versement des primes Vie des UPP et des points Challenges est donc
          suspendu.&nbsp;
        </DashboardInfoBannerCaption>
      </>
    )}
  </DashboardInfoBanner>
)

const Icon = styled(Minus)(({ theme }) => ({
  color: `${theme.palette.common.white}!important`,
  backgroundColor: theme.palette.negativeSegmentation.main,
  borderRadius: "100px",
}))
